(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ayd-home"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ayd-hero-slides')) {
 customElements.define('ayd-hero-slides', class extends HTMLElement {
  connectedCallback() {
   this.slides = Array.from(this.querySelectorAll('.ayd-hero-slide'));
   if (this.slides.length < 2) return;
   this.index = 0;
   this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
   this.paused = this.dataset.autoplay !== 'true' || this.motion.matches;
   this.querySelector('.ayd-slide-controls').hidden = true;
   this.controller = new AbortController();
   const options = {signal:this.controller.signal};
   this.querySelector('[data-prev]').addEventListener('click',()=>{this.paused=true;this.show(this.index-1);this.start();},options);
   this.querySelector('[data-next]').addEventListener('click',()=>{this.paused=true;this.show(this.index+1);this.start();},options);
   this.querySelector('[data-pause]').addEventListener('click',()=>{this.paused=!this.paused;this.start();},options);
   this.addEventListener('mouseenter',()=>{this.hovered=true;this.start();},options);
   this.addEventListener('mouseleave',()=>{this.hovered=false;this.start();},options);
   this.addEventListener('focusin',()=>{this.focused=true;this.start();},options);
   this.addEventListener('focusout',event=>{if(!this.contains(event.relatedTarget)){this.focused=false;this.start();}},options);
   document.addEventListener('visibilitychange',()=>this.start(),options);
   this.motion.addEventListener('change',()=>{if(this.motion.matches)this.paused=true;this.start();},options);
   this.show(0);this.start();
  }
  show(index) {
   this.index=(index+this.slides.length)%this.slides.length;
   this.slides.forEach((slide,i)=>{slide.classList.toggle('is-active',i===this.index);slide.setAttribute('aria-hidden',String(i!==this.index));});
   this.querySelector('[data-count]').textContent=`${this.index+1} / ${this.slides.length}`;
  }
  start() {
   clearInterval(this.timer);
   const button=this.querySelector('[data-pause]');
   button.setAttribute('aria-label',this.paused?button.dataset.play:button.dataset.stop);
   button.querySelector('[data-pause-icon]').textContent=this.paused?'▶':'Ⅱ';
   if(this.paused||this.hovered||this.focused||document.hidden)return;
   this.timer=setInterval(()=>this.show(this.index+1),Number(this.dataset.interval)||6000);
  }
  disconnectedCallback(){clearInterval(this.timer);this.controller?.abort();}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ayd-media"] && !Shopify.designMode) return;
  try {
    
function initAydMedia(root=document){root.querySelectorAll('[data-ayd-media]').forEach(section=>{if(section.dataset.ready)return;section.dataset.ready='true';const filters=section.querySelector('.ayd-media-filters');filters.hidden=false;filters.addEventListener('click',event=>{const button=event.target.closest('[data-ayd-filter]');if(!button)return;const value=button.dataset.aydFilter;filters.querySelectorAll('button').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));let count=0;section.querySelectorAll('[data-ayd-kind]').forEach(item=>{const show=value==='all_media'||item.dataset.aydKind===value;item.hidden=!show;if(show)count++;});section.querySelector('[data-ayd-visible-count]').textContent=count;section.querySelector('[data-ayd-empty]').hidden=count!==0;});});}initAydMedia();document.addEventListener('shopify:section:load',event=>initAydMedia(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
